module.exports = __webpack_public_path__ + "img/image-3.fb149897.jpg";